module.exports = __webpack_public_path__ + "img/WhatsAppVectop.83a401c.svg";